import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

const BG = "https://images.unsplash.com/photo-1584897356466-858d9b6c53d1?auto=format&fit=crop&w=1600&h=900&q=80";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate(location.state?.from || "/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-ink/85" />
      <div className="relative z-10 w-full max-w-md bg-surface/90 backdrop-blur-xl border border-white/10 rounded-2xl p-8 animate-fade-up">
        <Logo size="lg" className="mb-6" />
        <h1 className="font-display text-3xl font-black mb-6">Sign In</h1>
        {error && <p data-testid="login-error" className="bg-brand/15 text-brand text-sm rounded-md px-3 py-2 mb-4">{error}</p>}
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
          <button data-testid="login-submit" disabled={loading} className="w-full bg-brand hover:bg-brand/90 transition-colors rounded-md font-semibold py-3 flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
          </button>
        </form>
        <div className="flex justify-between text-sm text-white/60 mt-4">
          <Link to="/forgot-password" className="hover:text-white">Forgot password?</Link>
          <Link to="/register" data-testid="goto-register" className="hover:text-white">Create account</Link>
        </div>
      </div>
    </div>
  );
}
